import { render, staticRenderFns } from "./add-bank-account-widget.vue?vue&type=template&id=7043509e&"
import script from "./add-bank-account-widget.vue?vue&type=script&lang=js&"
export * from "./add-bank-account-widget.vue?vue&type=script&lang=js&"
import style0 from "./add-bank-account-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports